import { render, staticRenderFns } from "./BasicsWriteFirst.vue?vue&type=template&id=135ce28a&scoped=true"
import script from "./BasicsWriteFirst.vue?vue&type=script&lang=js"
export * from "./BasicsWriteFirst.vue?vue&type=script&lang=js"
import style0 from "./BasicsWriteFirst.vue?vue&type=style&index=0&id=135ce28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ce28a",
  null
  
)

export default component.exports